export const environment = {
  production: true,
  api_url: 'https://dev-api.bhave.life/api/v2/',
  sentry_dsn: 'https://28f8edeb28154d538ae90f58009cc216@sentry.io/1778316',
  pagseguro_redirect_url: 'https://sandbox.pagseguro.uol.com.br/v2/checkout/payment.html?code=',
  metabase_url: 'https://mb.bhave.life',
};
